<template>
  <div id="main-content" class="detail-bus">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <el-row>
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item>
            <el-button type="success" @click="goToEdit()">{{ $t('common.edit') }}</el-button>
            <el-button type="primary" @click="goToViewMap()">{{ $t('bus.check_seating_chart') }}</el-button>
          </el-form-item>
        </el-form>
      </el-row>
      <form v-if="busInfo">
        <el-row>
          <el-col :span="11" style="display: inline">
            <span class="form-lable">{{ $t('bus.name') }}:</span>
            <span class="info-span"> {{ busInfo.name }} </span>
          </el-col>
          <el-col :offset="1" :span="12" style="display: inline">
            <span class="form-lable">{{ $t('bus.brand') }}:</span>
            <span class="info-span"> {{ busInfo.brand }} </span>
          </el-col>
        </el-row>
        <el-row style="padding-top: 20px">
          <el-col :span="11" style="display: inline">
            <span class="form-lable">{{ $t('bus.total_seat') }}:</span>
            <span class="info-span"> {{ busInfo.seats }} </span>
          </el-col>
          <el-col :offset="1" :span="12" style="display: inline;">
            <span class="form-lable">{{ $t('bus.total_allowed_seats') }}:</span>
            <span class="info-span"> {{ busInfo.available_seats }} </span>
          </el-col>
        </el-row>
        <el-row style="padding-top: 20px">
          <el-col :span="11" style="display: inline">
            <span class="form-lable">{{ $t('bus.license_plate') }}:</span>
            <span class="info-span"> {{ busInfo.license_plate }} </span>
          </el-col>
          <el-col :offset="1" :span="12" style="display: inline">
            <span class="form-lable">{{ $t('bus.owner_type') }}:</span>
            <span class="info-span" v-if="busInfo.ownership_type == 1">{{ $t('bus.owned') }}</span>
            <span class="info-span" v-else-if="busInfo.ownership_type == 2">{{ $t('bus.rented') }}</span>
          </el-col>
        </el-row>
        <el-row style="padding-top: 20px">
          <el-col :span="11" style="display: inline">
            <span class="form-lable">{{ $t('common.year') }}:</span>
            <span class="info-span"> {{ busInfo.manufacture_year }} </span>
          </el-col>
          <el-col :offset="1" :span="12" style="display: inline">
            <span class="form-lable">{{ $t('bus.months_of_service_use') }}:</span>
            <span class="info-span"> {{ busInfo.used_month }} </span>
          </el-col>
        </el-row>
        <el-row style="padding-top: 20px">
          <el-col :span="11" style="display: inline">
            <span class="form-lable">{{ $t('bus.purchase_time') }}:</span>
            <span class="info-span"> {{ busInfo.buy_at }} </span>
          </el-col>
          <el-col :offset="1" :span="12" style="display: inline">
            <span class="form-lable">{{ $t('bus.rear_camera') }}:</span>
            <span class="info-span" v-if="busInfo.has_rear_camera == 1">{{ $t('common.yes') }}</span>
            <span class="info-span" v-else>{{ $t('common.no') }}</span>
          </el-col>
        </el-row>
        <el-row style="padding: 20px 0px">
          <el-col :span="11" style="display: inline">
            <span class="form-lable">{{ $t('bus.service_start_time') }}:</span>
            <span class="info-span"> {{ busInfo.used_at }} </span>
          </el-col>
          <el-col :offset="1" :span="12" style="display: inline">
            <span class="form-lable" style="width: 40%">{{ $t('common.image') }}</span>
            <img style="float: left" v-bind:src="busInfo.image" width="30%"/>
          </el-col>
        </el-row>
      </form>
    </el-col>
  </div>
</template>

<script>
  import PageTitle from '@/components/PageTitle'

  export default {
    name: "DetailBus",
    components: {
      PageTitle
    },
    data: function () {
      return {
        title: 'bus.bus_information',
        backLink: `/bus?action=back`,
        busInfo: null
      }
    },
    mounted: function () {
      let successCallback = (response) => {
        this.busInfo = Object.assign({}, response.data.data.bus_info)
      }
      let payload = {
        successCallback,
        bus_id: this.$route.query.bid
      }
      this.$store.dispatch('bus/getBusInfo', payload)
    },
    computed: {

    },
    methods: {
      goToEdit: function () {
        this.$router.push({path: '/bus/edit', query : { bid: this.$route.query.bid}});
      },
      goToViewMap: function () {
        this.$router.push({path: '/bus/setting-seat', query: {bid: this.$route.query.bid}})
      }
    }
  }
</script>

<style lang="scss">

</style>